import Cards from "./components/Cards";
import Header from "./components/header";
import Map from "./components/map";
import SectionHero from "./components/sectionHero";



function App() {
  return (
    <>
      <Header />
      <SectionHero />
      <Cards />
      <Map />
    </>
  );
}

export default App;
